module.exports = __webpack_public_path__ + "img/desalination-plant.9ab748ea.jpg";